(() => {
  const createDots = (counter, current, total, goTo) => {
    if (!counter || !current || !total || counter.dataset.dotsReady) return;

    counter.dataset.dotsReady = 'true';
    counter.classList.add('slider-counter--custom-dots');

    const dots = document.createElement('span');
    dots.className = 'slider-dots';
    counter.appendChild(dots);

    const render = () => {
      const count = parseInt(total.textContent, 10) || 0;
      const active = Math.max(1, parseInt(current.textContent, 10) || 1);

      if (dots.children.length !== count) {
        dots.replaceChildren();

        for (let index = 0; index < count; index++) {
          const dot = document.createElement('button');

          dot.type = 'button';
          dot.className = 'slider-dot';
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
          dot.addEventListener('click', () => goTo(index));

          dots.appendChild(dot);
        }
      }

      dots.hidden = count < 2;

      [...dots.children].forEach((dot, index) => {
        const selected = index === active - 1;

        dot.classList.toggle('is-active', selected);

        if (selected) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    const observer = new MutationObserver(render);

    observer.observe(current, {
      childList: true,
      characterData: true,
      subtree: true
    });

    observer.observe(total, {
      childList: true,
      characterData: true,
      subtree: true
    });

    render();
  };

  const initialize = (root) => {
    root.querySelectorAll('slider-component').forEach((slider) => {
      if (slider.querySelector('.slider-counter__link--dots')) return;

      const current = slider.querySelector('.slider-counter--current');
      const total = slider.querySelector('.slider-counter--total');
      const counter = current?.closest('.slider-counter');
      const track = slider.querySelector('.slider');

      if (!track) return;

      createDots(counter, current, total, (index) => {
        if (
          typeof slider.setSlidePosition === 'function' &&
          slider.sliderItemOffset
        ) {
          slider.setSlidePosition(index * slider.sliderItemOffset);
        } else {
          track.scrollTo({
            left: index * track.clientWidth,
            behavior: 'smooth'
          });
        }
      });
    });

    root.querySelectorAll('.video-gallery').forEach((gallery) => {
      const counter = gallery.querySelector('.video-gallery__counter');
      const current = gallery.querySelector('[data-current]');
      const total = gallery.querySelector('[data-total]');
      const track = gallery.querySelector('[data-track]');

      if (!track) return;

      createDots(counter, current, total, (index) => {
        track.scrollTo({
          left: index * track.clientWidth,
          behavior: 'smooth'
        });
      });
    });
  };

  const start = () => initialize(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();